<template>
  <div>
    <!-- <div class="hm-headline">
      <span class="headline">{{ title }}</span>
    </div> -->
    <slot name="header"></slot>
    <el-card shadow="never" class="hm-content">
      <slot />
      <div class="output pointer flex item-center" @click="outPutList">
        <el-badge is-dot class="item" :hidden="flag">
          <div>
            <div
              class="flex flex-center"
              style="width:13px;textAlign:center;marginLeft:5px;marginTop:5px"
            >
              <span>导出列队</span>
            </div>
          </div>
        </el-badge>
      </div>
      <el-tooltip
        class="item"
        effect="dark"
        content="意见反馈"
        placement="left"
        v-if="!disabled"
      >
        <div
          class="cs-style-1 pointer flex flex-center item-center"
          @click="gogo"
        >
          <div class="flex flex-center" style="width:13px;textAlign:center;">
            <span class="hmicon icon-yijianfankui"> </span>
          </div>
        </div>
      </el-tooltip>
      <el-drawer
        title="导出列队"
        :visible.sync="drawer"
        direction="rtl"
        size="700px"
      >
        <div class="p10">
          <el-radio-group
            @change="exportChange"
            v-model="searchCondition.exportStatus"
            size="small"
          >
            <el-radio-button label="complete">导出成功</el-radio-button>

            <el-radio-button label="wait"
              >导出列队（{{ waitNum }}）</el-radio-button
            >
            <el-radio-button label="fail">导出失败</el-radio-button>
          </el-radio-group>
          <div
            v-if="searchCondition.exportStatus === 'complete'"
            class="form-red"
          >
            导出成功的文件请尽快存放到本地，系统将于48h后清空。
          </div>
          <div style="height:700px" class="">
            <el-scrollbar style="height:100%" class="page-component__scroll">
              <el-table
                :data="list"
                style="width: 100%"
                id="table"
                size="small"
                :row-class-name="tableRowClassName"
              >
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="fileName"
                  label="文件名称"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-wrap item-center">
                      <el-tooltip
                        placement="top"
                        :content="scope.row.fileName"
                        effect="dark"
                      >
                        <div
                          class="text-overflow"
                          style="width:420px;fontSize:18px;color: #333;"
                        >
                          <span
                            v-if="scope.row.fileName"
                            class="hmicon icon-Excel mr10"
                            style="fontSize:24px;color: #72b498;"
                          ></span
                          >{{ scope.row.fileName }}
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="createTime"
                  label="创建时间"
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div
                      class="output-type"
                      v-if="scope.row.exportStatus === 'wait'"
                    >
                      导出中...
                    </div>
                    <div
                      class="output-type flex flex-center "
                      v-if="scope.row.exportStatus === 'complete'"
                    >
                      <!-- <el-button
                        size="small"
                        type="text"
                        class="danger"
                        style="fontSize:16px"
                        >删除</el-button
                      > -->
                      <el-button
                        size="small"
                        type="text"
                        style="fontSize:16px"
                        class="blue"
                        @click="save(scope.row)"
                        >保存到本地</el-button
                      >
                      <el-button
                        size="small"
                        type="text"
                        style="fontSize:16px"
                        class="blue"
                        @click="remove(scope.row)"
                        >删除</el-button
                      >
                    </div>
                    <div
                      class="danger"
                      style="marginRight:15px"
                      v-if="scope.row.exportStatus === 'exceed'"
                    >
                      导出过期
                    </div>
                    <div
                      class="danger"
                      style="marginRight:15px"
                      v-if="scope.row.exportStatus === 'fail'"
                    >
                      导出失败
                    </div>
                    <div
                      class="danger"
                      style="marginRight:15px"
                      v-if="scope.row.exportStatus === 'nodata'"
                    >
                      导出无数据
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div
                v-for="(v, i) in list"
                :key="i"
                class="outputlist flex flex-between item-center p10 mt10"
                :class="[
                  v.exportStatus === 'wait' || v.exportStatus === 'complete'
                    ? 'succeed'
                    : 'loser'
                ]"
              >
                <div class="flex flex-wrap item-center">
                  <span
                    class="hmicon icon-Excel mr10"
                    style="fontSize:24px;color: #72b498;"
                  ></span>
                  <el-tooltip
                    placement="top"
                    :content="v.fileName"
                    effect="dark"
                  >
                    <div class="text-overflow" style="width:420px">
                      {{ v.fileName }}
                    </div>
                  </el-tooltip>
                </div>
                <div
                  class="output-type"
                  style="marginRight:15px"
                  v-if="v.exportStatus === 'wait'"
                >
                  导出中...
                </div>
                <div
                  class="output-type"
                  style="marginRight:15px"
                  v-if="v.exportStatus === 'complete'"
                >
                  <el-button
                    size="small"
                    type="text"
                    class="danger"
                    style="fontSize:16px"
                    >删除</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    style="fontSize:16px"
                    class="blue"
                    @click="save(v)"
                    >保存到本地</el-button
                  >
                </div>
                <div
                  class="danger"
                  style="marginRight:15px"
                  v-if="v.exportStatus === 'exceed'"
                >
                  导出过期
                </div>
                <div
                  class="danger"
                  style="marginRight:15px"
                  v-if="v.exportStatus === 'fail'"
                >
                  导出失败
                </div>
                <div
                  class="danger"
                  style="marginRight:15px"
                  v-if="v.exportStatus === 'nodata'"
                >
                  导出无数据
                </div>
              </div> -->
            </el-scrollbar>
          </div>
        </div>
      </el-drawer>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    title: { type: String },
    hidden: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      disabled: false,
      waitNum: 0,
      list: [],
      drawer: false,
      searchCondition: {
        exportStatus: "wait"
      },
      row: {},
      flag: this.hidden
    };
  },
  computed: {},
  watch: {
    hidden(val) {
      this.flag = val;
    }
  },
  mounted() {
    this.disabled = false;
    this.queryExportQueueSign();
  },
  methods: {
    async remove(row) {
      const result = await this.$confirm("删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("removeQueueRow", {
          id: row.id
        });
        this.queryExportList();
      }
    },
    gogo() {
      window.open("https://support.qq.com/product/173273");
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 0);
    },
    async queryExportQueueSign() {
      const { result } = await this.$store.dispatch("queryExportQueueSign");
      if (result !== "0") {
        this.flag = false;
      }
    },
    tableRowClassName({ row }) {
      if (row.exportStatus === "wait" || row.exportStatus === "complete") {
        return "succeed";
      } else {
        return "loser";
      }
    },
    exportChange() {
      this.queryExportList();
    },
    save(row) {
      this.row = row;
      // axios
      //   .post(
      //     this.$serverAdress +
      //       `/sys/common/download?fileName=${row.exportSuccFilePath}`
      //   )
      //   .then(res => {
      //     this.download(res.data);
      //   })
      //   .catch(err => {
      //     throw new Error(err);
      //   });
      // this.$store
      //   .dispatch("downloadReport", { filePath: row.exportSuccFilePath })
      //   .then(res => {
      //     this.download(res.data);
      //   });

      axios({
        method: "post",
        url:
          this.$serverAdress +
          `/sys/common/download?filePath=${row.exportSuccFilePath}`,
        responseType: "arraybuffer"
      }).then(res => {
        this.download(res.data);
      });
      // this.$store
      //   .dispatch("downloadFile", {
      //     exportSuccFilePath: row.exportSuccFilePath
      //   })
      //   .then(res => {
      //     this.download(res);
      //   });
    },
    download(data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.row.fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    async queryExportList() {
      const { result } = await this.$store.dispatch(
        "queryExportQueueList",
        this.searchCondition
      );
      this.list = result;
      if (this.searchCondition.exportStatus === "wait") {
        this.waitNum = this.list.length;
      }
    },
    outPutList() {
      this.queryExportList();
      this.flag = true;
      this.drawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  }
};
</script>
<style lang="scss">
.page-component__scroll {
  height: 100%;
}
.page-component__scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-table .succeed {
  background: #e6fbf2;
  .output-type {
    color: #72b498;
    z-index: 9999999;
  }
  // background: rgba(255, 240, 240, 1);
  // border: 1px solid rgba(255, 0, 0, 1);
  z-index: 9999999;
}
.el-table .loser {
  background: rgba(247, 247, 247, 1);
  .output-type {
    color: rgba(0, 129, 229, 1);
    z-index: 9999999;
  }
  z-index: 9999999;
}
</style>
<style scoped lang="scss">
// 标题全局样式
.hm-headline {
  padding: 0.5rem 0;
  margin-bottom: 10px;
  .headline {
    border-left: 3px solid#E50065;
    padding-left: 10px;
    font-size: 14px;
    color: #333;
  }
}
.hm-content {
  margin-bottom: 64px;
  min-height: calc(100vh - 165px);
  font-size: 14px;
}
.outputlist {
  border-radius: 4px;
}
.succeed {
  background: #e6fbf2;
  .output-type {
    color: #72b498;
  }
}
.loser {
  background: rgba(247, 247, 247, 1);
  .output-type {
    color: rgba(0, 129, 229, 1);
  }
}
.output {
  position: fixed;
  right: -5px;
  // bottom: 200px;
  // width: 50px;
  // height: 100px;
  top: calc(65% - 30px);
  // margin-top: -36px;
  width: 28px;
  height: 60px;
  // background-color: #2b2b2b;
  // color: #fff;
  transition: all 0.3s;
  font-size: 12px;
  color: #fff;
  z-index: 1;
  background: rgba(44, 44, 44, 1);
  box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 1);
  border-radius: 0 2px 2px 0;
  padding: 8px 7px;
  line-height: 14px;
}
.output:hover {
  position: fixed;
  right: 0;
  bottom: 200px;
  z-index: 2;
  display: flex !important;
  display: -webkit-flex !important;
  justify-content: center;
  -webkit-justify-content: center;
  // background: #f1f1f1;
  // transform: translateX(-9px);
}
.cs-style-1 {
  width: 28px;
  position: fixed;
  right: -5px;
  top: calc(65% + 60px);
  opacity: 1;
  z-index: 1;
  color: #505050;
  z-index: 1;
  background: rgba(44, 44, 44, 1);
  color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 1);
  border-radius: 0 2px 2px 0;
  transition: all 0.3s;
  padding: 8px 7px;
}
.cs-style-1:hover {
  opacity: 1;
  // width: 50px;
  // height: 50px;
  position: fixed;
  right: 0;
  top: calc(65% + 60px);
  z-index: 1;
  // transform: translate(15px, 15px);
  // -webkit-transform: translate(15px, 15px);
}
</style>
